import angular from 'angular';
import evidenceComponent from './evidence.component';

import articleEvidenceModule from './article-evidence/article-evidence';
import imageEvidenceModule from './image-evidence/image-evidence';

let childModules = [
    articleEvidenceModule,
    imageEvidenceModule
];

let moduleNames = [];

let states = [
    {
        name: 'evidence',
        url: '/evidence',
        component: 'evidence'
    }
];

childModules.forEach((m) => {
    moduleNames.push(m.name);

    m.states.forEach((s) => {
        s.name = 'evidence.' + s.name;
        states.push(s);
    });
});

let evidenceModule = angular.module('evidence', moduleNames)

    .component('evidence', evidenceComponent)

    .name;

export default {name: evidenceModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/evidence/evidence.js